import { Box, Fade, Zoom } from '@mui/material';
import { styled } from '@mui/material/styles';
import TextControlBar from 'Components/WelcomeSlides/TextControlBar';
import { ThemeTypography } from 'DesignSystem';
import bulb from 'assets/img/welcomeSlides/icon_bulb_plant.svg';
import impactClaimBanner from 'assets/img/welcomeSlides/impact-claims-banner.png';
import mobileView from 'assets/img/welcomeSlides/mobile-view.png';
import pulseLine from 'assets/img/welcomeSlides/pulse-line-3.svg';
import React, { FC } from 'react';
import {
  ContentContainer,
  Headline,
  ImageContainer,
  Item,
  ItemIcon,
  ItemIconContainer,
  ItemText,
  PageContainer,
} from './styles';

interface IPublishProductsProps {
  active: boolean;
}

const StyledPulse = styled('img')(({ theme }) => ({
  position: 'absolute',
  left: theme.spacing(0),
  width: '380px !important',
  bottom: 50,
}));

const QrCode = styled('img')(() => ({
  width: '176px !important',
}));

const ImpactClaimBanner = styled('img')(() => ({
  width: '90% !important',
}));

const PublishProducts: FC<IPublishProductsProps> = ({ active }) => {
  return (
    <>
      <PageContainer>
        <Zoom in={active}>
          <ContentContainer>
            <Box mb={1.5}>
              <Item>
                <ItemIconContainer>
                  <ItemIcon width={20} src={bulb} alt="Bulb" />
                </ItemIconContainer>
                <ItemText dangerouslySetInnerHTML={{ __html: 'Prove your <br /> impact' }} />
              </Item>
            </Box>
            <Headline variant="TITLE_LARGE">Publish your products</Headline>
            <ThemeTypography variant="TITLE_EXTRA_SMALL">
              Publish and share your product pages & impact claims on all channels.
            </ThemeTypography>
            <Zoom in={active}>
              <StyledPulse src={pulseLine} alt="pulse" />
            </Zoom>
          </ContentContainer>
        </Zoom>
        <Fade in={active} timeout={400}>
          <ImageContainer>
            <QrCode alt="Label with qr code" src={mobileView} />
            <Box
              width="100%"
              display="flex"
              justifyContent="flex-end"
              position="absolute"
              bottom={32}
            >
              <ImpactClaimBanner src={impactClaimBanner} alt="Impact claims banner" />
            </Box>
          </ImageContainer>
        </Fade>
      </PageContainer>
      <TextControlBar />
    </>
  );
};

export default PublishProducts;
